import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Line } from "react-chartjs-2";

import leftIcon from "../_assets/images/left_icon.png";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import moment from "moment";
import { MixpanelService } from "../_service/mixpanel.service";
import { Loader } from "../_components/loader.component";
import { Card, DateRangePicker, Flex, Grid } from "@tremor/react";
import KpiCard from "../_components/mixpanelComponents/KpiCard";
import ChartView from "../_components/mixpanelComponents/ChartView";
import DonutView from "../_components/mixpanelComponents/DonutView";
import BarView from "../_components/mixpanelComponents/BarView";

export const MIXPANEL_ROUTE = "/mixpanel";

const MixPanel = ({ history, user, addToast }) => {
  const [widgetData, setWidgetData] = useState([]);
  const [graphsData, setgraphsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let allGraphData = [];
  let allWidgetData = [];

  const [selectedView, setSelectedView] = useState("1");
  const [dateRange, setDateRange] = useState([
    new Date(2023, 2, 5),
    new Date(),
  ]);

  useEffect(() => {
    // getMixpanelData();
  }, []);

  // const getMixpanelData = () => {
  //   setIsLoading(true);
  //   MixpanelService.getMixpanelData(user)
  //     .then((resp) => {
  //       if (resp.length >= 1) {
  //         handleMixpanelData(resp);
  //       } else {
  //         setIsLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       setIsLoading(false);
  //       if (error && error.response && error.response.data.message) {
  //         addToast(error.response.data.message, "", ToastTypes.danger);
  //       }
  //     });
  // };

  // const handleMixpanelData = (mixData) => {
  //   let allMixpanelData = mixData.filter((item) => item !== null);
  //   allMixpanelData.map(async (item) => {
  //     if (Object.keys(item.series[item.metric_key]).length > 1) {
  //       let labels = Object.keys(item.series[Object.keys(item.series)[0]]);
  //       let data = labels.map(
  //         (ite) => item.series[Object.keys(item.series)[0]][ite]
  //       );
  //       labels = labels.map((lbl) => moment(lbl).format("MMM DD"));
  //       let tempObject = {
  //         data: data.reverse(),
  //         labels: labels.reverse(),
  //         title: Object.keys(item.series)[0],
  //       };
  //       await allGraphData.push(tempObject);
  //     } else {
  //       let labels = Object.keys(item.series[Object.keys(item.series)[0]]);
  //       let data = labels.map(
  //         (ite) => item.series[Object.keys(item.series)[0]][ite]
  //       );
  //       let tempGraphObj = {
  //         data: data[0],
  //         title: Object.keys(item.series)[0],
  //       };
  //       await allWidgetData.push(tempGraphObj);
  //     }
  //   });
  //   setIsLoading(false);
  //   setgraphsData(allGraphData);
  //   setWidgetData(allWidgetData);
  // };

  return (
    <div className="page-container ml-auto px-9 py-6 org-management-container survey-page-container vit-mixpanel-container">
      <div className="flex pb-4 back-btn-container items-center cursor-pointer vit-back-btn-container">
        <img src={leftIcon} alt="" onClick={() => history.push("/")} />
        <span
          className="ml-3 text-xl home-text t-grey"
          onClick={() => history.push("/")}>
          Home
        </span>
      </div>
      <div className="md:flex justify-between">
        <DateRangePicker
          className="max-w-sm pt-3"
          value={dateRange}
          onValueChange={setDateRange}
          minDate={new Date(2023, 2, 5)} // Our launch date was March 5th, 2023
        />
      </div>
      <>
        {/* <div className="flex justify-between vit-mixpanel-data-container">
            <div className="w-3/4">
              {graphsData.map((element, ind) => {
                return (
                  <div
                    className="card rounded-md bg-white p-8 mt-4"
                    style={{ minHeight: "45vh" }}
                    key={ind}>
                    <div className="mb-3">
                      <span className="font-bold text-xl text-primary">
                        {element.title}
                      </span>
                    </div>
                    <div className="flex">
                      <div style={{ width: "100%" }}>
                        <Line
                          data={{
                            labels: element.labels,
                            datasets: [
                              {
                                label: element.title,
                                data: element.data,
                                borderColor: "#576CD0",
                                backgroundColor: "#576CD0",
                                pointRadius: 0,
                              },
                            ],
                          }}
                          options={{
                            responsive: true,
                            plugins: {
                              legend: {
                                display: false,
                              },
                            },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="w-1/4">
              <div
                className="pt-4 grid pl-4 pr-4"
                style={{
                  gridTemplateColumns: "100%",
                  columnGap: "10px",
                  rowGap: "10px",
                }}>
                {widgetData.map((element, ind) => {
                  return (
                    <div
                      className="card rounded-md bg-white py-8 px-4"
                      key={ind}>
                      <div className="pl-3 border-left">
                        <p className="text-base text-primary font-bold text-center">
                          {element.title}
                        </p>
                        <p className="text-base t-grey font-bold text-lg text-center py-4">
                          {element.data.toString().indexOf(".") > 0
                            ? element.data.toFixed(1)
                            : element.data}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div> */}
        <Grid numColsMd={3} numColsLg={5} className="mt-6 gap-6">
          <KpiCard
            dateRange={dateRange}
            event={"Signed up"}
            title={"# of signups"}
          />
          <KpiCard
            dateRange={dateRange}
            event={"One-on-One request submitted"}
            title={"# of 1:1 requests"}
          />
          <KpiCard
            dateRange={dateRange}
            event={"Coaching session subscribed"}
            title={"# of sessions signups"}
          />
          <KpiCard
            dateRange={dateRange}
            event={"Coaching session"}
            title={"# of sessions joined"}
          />
          <KpiCard
            dateRange={dateRange}
            event={"Meditation track started"}
            title={"# of meditation tracks listened to"}
          />
          <KpiCard
            dateRange={dateRange}
            event={"Daily check-in completed"}
            title={"# of daily check-ins"}
          />
          <KpiCard
            dateRange={dateRange}
            event={"Peer support message sent"}
            title={"# of peer messages sent"}
          />
          <KpiCard
            dateRange={dateRange}
            event={"Additional resources tapped"}
            title={"# of times additional resources tapped"}
          />
        </Grid>
        <Grid numColsMd={2} numColsLg={2} className="mt-6 gap-6">
          <ChartView
            dateRange={dateRange}
            events={["Signed up"]}
            title={"# of sign ups"}
            cumulative={true}
          />
          <ChartView
            dateRange={dateRange}
            events={[
              "Coaching session subscribed",
              "One-on-One request submitted",
            ]}
            title={"Coaching signups"}
            cumulative={true}
          />
          <ChartView
            dateRange={dateRange}
            events={["Meditation track started"]}
            title={"# of meditation tracks listened to"}
            cumulative={false}
          />
          <ChartView
            dateRange={dateRange}
            events={["Daily check-in completed"]}
            title={"# of daily check-ins"}
          />
        </Grid>
        <Grid numColsMd={2} numColsLg={3} className="mt-6 gap-6">
          <DonutView
            dateRange={dateRange}
            event="Mindfulness category tapped"
            property="category"
            title={"Taps by meditation category"}
          />
          <DonutView
            dateRange={dateRange}
            event="New journal entry created"
            property="mood"
            title={"Journal mood distributions"}
          />
          <BarView
            dateRange={dateRange}
            event="Group joined"
            property="name"
            title={"# of signups by peer group"}
          />
        </Grid>
      </>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth,
});

const MixPanelPage = withToast(connect(mapStateToProps)(MixPanel));

export default MixPanelPage;
